<template>
  <v-container class="CreaTextBlock">
    <v-tooltip open-delay="500" color="rgba(var(--removeObject-rgb),.9)" bottom>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" small depressed dark fab @click="removeComponent" class="delete_button">
          <v-icon>mdi-trash-can-outline</v-icon>
        </v-btn>
      </template>
      <span>Supprimer</span>
    </v-tooltip>
    <div class="div-textarea" >
      <v-textarea
          color="rgb(var(--new-media-rgb))"
          label="Votre texte"
          v-model="text"
          rows="1"
          @change="addText"
        ></v-textarea>
    </div>
    <div class="custom-center div-flex-space-between">
      <v-btn-toggle v-model="fontStyle" @change="addText" group multiple color="rgb(var(--new-media-rgb))">
        <v-tooltip color="rgba(var(--new-media-rgb),1)" bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" value="bold" style="border-radius:50em"><span class="headline font-weight-black">G</span></v-btn>
          </template>
          <span>Gras</span>
        </v-tooltip >
        <v-tooltip color="rgba(var(--new-media-rgb),1)" bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" value="underline" style="border-radius:50em;"><span class="headline font-weight-medium underline" style="text-decoration:underline">S</span></v-btn>
          </template>
          <span>Souligné</span>
        </v-tooltip>
        <v-tooltip color="rgba(var(--new-media-rgb),1)" bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" value="line-through" style="border-radius:50em;"><span class="headline font-weight-medium line-through" style="text-decoration:line-through">B</span></v-btn>
          </template>
          <span>Barré</span>
        </v-tooltip>
      </v-btn-toggle>
      <v-menu :close-on-content-click="false" offset-y :offsetOverflow="true" left>
        <template v-slot:activator="{ on: menu }">
          <v-tooltip color="rgba(var(--new-media-rgb),1)" bottom>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn height="36px" dark width="36px" style="box-shadow: 0px 0px 0px 2px rgba(0,0,0,0.3)!important;" fab depressed small v-on="{...tooltip, ...menu}" :color="chosenColor" @click="setColorPickerVisibility">
                <v-icon class="pt-1">mdi-format-color-fill</v-icon>
              </v-btn>
            </template>
            <span>Couleur</span>
          </v-tooltip>
        </template>
        <v-color-picker @change="addText" v-model="chosenColor" canvas-height="100" width="250" mode="hexa" :hide-mode-switch="hideSwitch" class="d-inline-block" ></v-color-picker>
      </v-menu>
      <div>
        <v-select return-object dense outlined rounded single-line hide-details class="custom-select" color="new_media" item-color="new_media" :menu-props="{offsetY: true, offsetOverflow:true, maxHeight: 300}" append-icon="mdi-chevron-down" style="width:140px;" item-value="text" label="Arial" :items="fonts" v-model="chosenFont" @change="addText">
          <template  slot="item" slot-scope="data">
            <span :style="`font-family: ${data.item.fontFamily}`">{{ data.item.text }}</span>
          </template>
        </v-select>
<!--    <select v-model="chosenFont" @change="addText" :class="chosenFont">
        <option v-for="font in fonts" :value="font.fontFamily" :key="font.name" :class="font.fontFamily">
          {{ font.name }}
        </option>
      </select> j'ai tout changé ici en v-select donc je pense qu'on peut virer ce bloc // Benix
-->
      </div>
    </div>
  <!--  <v-menu :close-on-content-click="false" offset-y>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" :color="chosenColor" @click="setColorPickerVisibility"><v-icon>mdi-palette</v-icon></v-btn>
      </template>
    </v-menu> -->
    <!-- <v-btn :color="chosenColor" @click="setColorPickerVisibility"><v-icon>mdi-palette</v-icon> </v-btn> -->
  </v-container>
</template>

<script>
import Konva from 'konva'
export default {
  props: ['data'],
  data () {
    return {
      text: '',
      hideInputs: true,
      chosenColor: '#16C979FF',
      colorVisible: false,
      hideSwitch: true,
/*       selectClass: this.$store.state.theme === 'dark' ? 'darkSelect' : 'lightSelect',
 */      chosenFont: 'Arial',
      fonts: [
        {text: 'Arial', fontFamily: 'arial'},
        {text: 'Aller', fontFamily: 'aller'},
        {text: 'Arvo', fontFamily: 'arvo'},
        {text: 'Chancery', fontFamily: 'chancery'},
        {text: 'Desyrel', fontFamily: 'desyrel'},
        {text: 'Drunken', fontFamily: 'drunkenSerif'},
        {text: 'Futura', fontFamily: 'futura'},
        {text: 'Gothic', fontFamily: 'gothic'},
        {text: 'Komika', fontFamily: 'komika'},
        {text: 'Stencil', fontFamily: 'stencil'},
        {text: 'Sciences', fontFamily: 'sciences'}
      ],
      id: this.data + '-text',
      fontStyle: []
    }
  },
  methods: {
    setColorPickerVisibility () {
      this.colorVisible = !this.colorVisible
    },
    addText () {
      var konvaText = new Konva.Text({
        draggable: true,
        x: 10,
        y: 10,
        fontSize: 24,
        fontFamily: this.chosenFont.fontFamily,
        fill: this.chosenColor,
        text: this.text,
        id: this.id
      })
      if (this.fontStyle.includes('underline') && this.fontStyle.includes('line-through')) {
        konvaText.textDecoration('underline line-through')
      } else if (this.fontStyle.includes('underline') && !this.fontStyle.includes('line-through')) {
        konvaText.textDecoration('underline')
      } else if (!this.fontStyle.includes('underline') && this.fontStyle.includes('line-through')) {
        konvaText.textDecoration('line-through')
      }
      if (this.fontStyle.includes('bold')) {
        konvaText.fontStyle('bold')
      }
      this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.addText(konvaText)
    },
    removeComponent () {
      var konvaText = new Konva.Text({
        draggable: true,
        x: 10,
        y: 10,
        fontSize: 24,
        fontFamily: this.chosenFont,
        fill: this.chosenColor,
        text: '',
        id: this.id
      })
      this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.addText(konvaText)
      this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.removeTextBlock(this.data)
    }
  },
  watch: {
    chosenColor: function () {
      if (this.text) {
        this.addText()
      }
    }
  }
}
</script>

<style scoped>

option{
  font-size: 20px;
}

.v--modal-box{
  overflow: auto;
  max-height: 800px
}

.drunkenSerif {
font-family: drunkenSerif;
}

.desyrel {
font-family: desyrel;
}

.arial {
font-family: arial;
}

.arvo {
font-family: arvo;
}

.aller {
font-family: aller;
}

.stencil {
font-family: stencil;
}

.komika {
font-family: komika;
}

.sciences {
font-family: sciences;
}

.chancery {
font-family: chancery;
}

.gothic {
font-family: gothic;
}

.futura {
font-family: futura;
}
</style>
